import React, { useState, useRef } from 'react'
import { Form, Row, Col, Input, Button } from 'antd'
import firebase from 'gatsby-plugin-firebase'
import { normalizePhoneNumberInput } from '../../../utils/form/normalize'
import SuccessModal from '../../../components/SuccessModal'

const FamOrderForm = () => {
  const formRef = useRef(null)

  const [loading, setLoading] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)

  const handleFamSubmit = values => {
    values.timestamp = new Date().toLocaleString('en-US', {
      timeZone: 'America/New_York'
    })
    // Replace all undefined values with empty strings
    const convertedString = JSON.stringify(values, function (key, value) {
      return value === undefined ? '' : value
    })
    const updatedValues = JSON.parse(convertedString)
    const famOrderFormMessageObj = {
      to: updatedValues.email,
      bcc: [
        'info@nofloodflorida.com',
        'sophia@nofloodflorida.com',
        'nofloodflorida+7t5d67e@nofloodflorida-org.myfreshworks.com'
      ],
      template: {
        name: 'famOrderFormTemplate',
        data: {
          ...updatedValues
        }
      }
    }

    firebase
      .firestore()
      .collection('famOrderForm')
      .add(famOrderFormMessageObj)
      .then(() => {
        setIsModalVisible(true)
        formRef.current.resetFields()
      })
      .catch(error => console.log('Error adding document:', error))
  }

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo)
  }

  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 }
  }

  const handleOk = () => setIsModalVisible(false)
  const handleCancel = () => setIsModalVisible(false)

  return (
    <>
      <SuccessModal
        content="Form Submitted Successfully! Please check your email and/or spam folder for a confirmation."
        isModalVisible={isModalVisible}
        handleCancel={handleCancel}
        handleOk={handleOk}
      />
      <Form
        {...layout}
        ref={formRef}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={handleFamSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[20, 0]}>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: 'Please input your name!' }]}
            >
              <Input
                className="round"
                size="large"
                allowClear={true}
                placeholder="John Doe"
              />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: 'Please input your email!'
                }
              ]}
            >
              <Input
                className="round"
                size="large"
                allowClear={true}
                placeholder="info@nofloodflorida.com"
                onInput={e =>
                  (e.target.value = ('' + e.target.value).toLowerCase())
                }
              />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              normalize={(value, prevValue, prevValues) =>
                normalizePhoneNumberInput(value, prevValue)
              }
              label="Phone"
              name="phone"
              rules={[
                { required: true, message: 'Please input your phone number.' }
              ]}
            >
              <Input
                className="round"
                size="large"
                allowClear={true}
                placeholder="(813) 213-0641"
              />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={24} sm={24} xs={24}>
            <Form.Item
              label="Address (include City and Zip Code)"
              name="address"
              rules={[
                { required: true, message: 'Please input your address!' }
              ]}
            >
              <Input
                className="round"
                placeholder="123 Main St, Tampa, FL 33624"
                size="large"
                allowClear={true}
                onInput={e =>
                  (e.target.value = ('' + e.target.value).toUpperCase())
                }
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Message" name="message">
              <Input.TextArea className="round" />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="end">
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="box-shadow"
              shape="round"
              size="large"
              loading={loading}
            >
              Submit
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </>
  )
}

export default FamOrderForm
